export const WARNING = 'warning';
export const DANGER = 'danger';

export const WARNING_MESSAGE_CLASS = 'warning_message';
export const DANGER_MESSAGE_CLASS = 'danger_message';

export const MWPS_MERGE_STRATEGY = 'merge_when_pipeline_succeeds';
export const ATMTWPS_MERGE_STRATEGY = 'add_to_merge_train_when_pipeline_succeeds';
export const MT_MERGE_STRATEGY = 'merge_train';

export const AUTO_MERGE_STRATEGIES = [
  MWPS_MERGE_STRATEGY,
  ATMTWPS_MERGE_STRATEGY,
  MT_MERGE_STRATEGY,
];
